import { Reveal } from "./Reveal";
import { Terminal } from "lucide-react";

const PROMPTS = [
  "I need a commercial yard in Surrey.",
  "I have £20,000 and want to start a business.",
  "I have skills and equipment. Who needs them?",
];

export const FutureAI = () => (
  <section id="findx-ai" data-testid="findx-ai-section" className="relative py-28 lg:py-36 border-t border-white/5 bg-grid overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 50% 45% at 50% 100%, rgba(0,240,255,0.05), transparent 65%)" }}
    />
    <div className="max-w-5xl mx-auto px-6 lg:px-10">
      <Reveal className="text-center">
        <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="ai-eyebrow">
          /// FUTURE VISION
        </span>
        <h2 className="mt-6 font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100" data-testid="ai-title">
          FINDX <span className="text-[#00F0FF]">AI</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-slate-400 text-base sm:text-lg leading-relaxed" data-testid="ai-description">
          Where the network is heading: an intelligence layer that understands what you need
          and what you offer — and finds the intersection for you. FINDX AI is a concept in
          development. It does not exist yet. This is the road we're building towards.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-14 card-frame !bg-[#070A10]" data-testid="ai-terminal">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-white/10">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-[#8A2BE2]/70" />
              <span className="w-2.5 h-2.5 rounded-full bg-[#00F0FF]/50" />
              <span className="w-2.5 h-2.5 rounded-full bg-white/15" />
            </div>
            <span className="flex items-center gap-2 font-mono-accent text-[10px] tracking-[0.3em] text-slate-600">
              <Terminal size={12} />
              FINDX AI — CONCEPT TERMINAL
            </span>
            <span className="font-mono-accent text-[10px] tracking-[0.25em] text-[#FFC700]/80 border border-[#FFC700]/30 px-2 py-0.5" data-testid="ai-status-badge">
              IN DEVELOPMENT
            </span>
          </div>
          <div className="p-6 sm:p-10 space-y-5">
            {PROMPTS.map((p, i) => (
              <div
                key={p}
                className="group flex items-start gap-4 border border-white/5 bg-white/[0.015] px-5 py-4 transition-colors duration-300 hover:border-[#00F0FF]/30"
                data-testid={`ai-prompt-${i}`}
              >
                <span className="font-mono-accent text-[#00F0FF] text-sm mt-0.5">&gt;</span>
                <span className="font-mono-accent text-sm sm:text-base text-slate-300 leading-relaxed">{p}</span>
              </div>
            ))}
            <div className="flex items-center gap-2 px-5 pt-2">
              <span className="font-mono-accent text-[#00F0FF] text-sm">&gt;</span>
              <span className="font-mono-accent text-sm text-slate-600">What would you ask?</span>
              <span className="w-2 h-4 bg-[#00F0FF] animate-caret" />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
